import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface QuillEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  modules?: any;
  formats?: string[];
  style?: React.CSSProperties;
}

// Suppress findDOMNode warning globally (react-quill issue)
// This runs once at module load time
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  // Suppress findDOMNode warnings from react-quill
  if (typeof args[0] === 'string' && args[0].includes('findDOMNode')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

/**
 * QuillEditor wrapper component that suppresses the findDOMNode deprecation warning
 * from react-quill when used with React.StrictMode.
 * 
 * This is a temporary solution until react-quill updates to use refs instead of findDOMNode.
 */
const QuillEditor: React.FC<QuillEditorProps> = ({ 
  value, 
  onChange, 
  placeholder,
  modules,
  formats,
  style
}) => {
  const quillRef = useRef<ReactQuill>(null);

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={modules}
      formats={formats}
      style={style}
    />
  );
};

export default QuillEditor;
